'use client'

import { useState } from "react";
import styles from './Newsletter.module.css';
import classNames from "classnames";
import HubSpotForm from '@/components/HubSpotForm/HubSpotForm';
import CookieConsent from '@/components/CookieConsent/CookieConsent';
import { useCookieConsent } from "@/hooks/useCookieConsent";
import MessageDefault from "../MessageDefault/MessageDefault";

function Newsletter() {
    
    const { consent } = useCookieConsent(); 

    return (
        <section className={styles.newsletter}>
            <CookieConsent />
            <div className="uiContainer">
                <div className={styles.dFlex}>
                    <h2 tabIndex={0} className={classNames(styles.titlePadrao, styles.titNewsletter)}>
                        Receba nossa Newsletter
                    </h2>
                    {
                        !!consent && !consent?.funcionalidades ? (
                            <MessageDefault/>
                        ) : (
                            <HubSpotForm consentGiven={consent?.funcionalidades} />
                        )
                    }
                </div>
            </div>
        </section>
    );
}


export default Newsletter;

